"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaRelatedOperationToJSON = exports.RosettaRelatedOperationFromJSONTyped = exports.RosettaRelatedOperationFromJSON = void 0;
const runtime_1 = require("../runtime");
function RosettaRelatedOperationFromJSON(json) {
    return RosettaRelatedOperationFromJSONTyped(json, false);
}
exports.RosettaRelatedOperationFromJSON = RosettaRelatedOperationFromJSON;
function RosettaRelatedOperationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'index': json['index'],
        'network_index': !runtime_1.exists(json, 'network_index') ? undefined : json['network_index'],
    };
}
exports.RosettaRelatedOperationFromJSONTyped = RosettaRelatedOperationFromJSONTyped;
function RosettaRelatedOperationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'index': value.index,
        'network_index': value.network_index,
    };
}
exports.RosettaRelatedOperationToJSON = RosettaRelatedOperationToJSON;
//# sourceMappingURL=RosettaRelatedOperation.js.map